module.exports = __webpack_public_path__ + "img/3x.6ee36f7.jpg";